import { SvgIcon, SvgIconProps } from '@mui/material';

/** The BreedLOGIC "B" brand mark (same path as /breedlogic-shell-logo.svg), theme-coloured. */
export function BreedlogicMarkIcon(props: SvgIconProps) {
  return (
    <SvgIcon viewBox="0 0 15 20" {...props}>
      <path
        d="M11.0134 9.12226C12.6112 8.55799 13.5419 6.58307 13.5419 5.10972C13.5419 3.63636 12.999 2.39812 11.8976 1.45768C10.8273 0.485893 9.49328 0 7.89555 0H2.17166C0.992761 0 0.0310238 0.971787 0.0310238 2.16301V9.2163C0.0310238 10.4232 0.992761 11.6458 2.17166 11.6458H8.19028C9.49328 11.6458 10.6256 12.4295 10.6412 13.7461C10.6567 15.094 9.58635 16.0031 8.26784 16.0031H4.29679V12.5549L0 16.9749V17.837C0 19.0282 0.961737 20 2.14064 20H8.95036C10.6722 20 12.0993 19.4514 13.2316 18.3386C14.395 17.2257 14.969 15.7837 14.969 14.0909H15C15 11.5361 13.5419 9.5768 11.0134 9.12226ZM7.11996 8.0094H4.28128V3.99687H7.11996C8.31437 3.99687 9.27611 4.76489 9.27611 5.97179C9.27611 7.17868 8.31437 8.0094 7.11996 8.0094Z"
        fill="currentColor"
      />
    </SvgIcon>
  );
}
